/**
 * Series request.
 */
import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IFastEventRequest } from '@shared/types/interfaces/event';
import { IRailData, ISeriesRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';

/**
 * Series request.
 * @param id - The id of the series.
 * @returns A promise that resolves to an array of rails.
 */
export default function seriesRequest(id: string) {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const response: ISeriesRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v1',
          section: 'apiseries',
          subsection: 'series',
          type: 'seasons',
          params: '?withEpisodes=true&filterByAvailability=false',
          replacement: id,
        },
      })) as unknown as ISeriesRequest;

      let rails = response.data.items.map((item) => {
        const episodes = item?.episodes
          ?.sort((episode1, episode2) => {
            return episode1?.episode && episode2?.episode
              ? episode1?.episode < episode2?.episode
                ? -1
                : 1
              : 0;
          })
          // Filter repeated items
          .reduce((prevData: IFastEventRequest[], currentEpisode) => {
            if (prevData.length) {
              const previousEpisode = prevData.at(-1);
              if (
                currentEpisode &&
                previousEpisode &&
                currentEpisode.episode &&
                previousEpisode.episode &&
                previousEpisode?.season === currentEpisode?.season &&
                previousEpisode.episode === currentEpisode.episode
              ) {
                const beginCurrent = new Date(
                  currentEpisode?.beginTime || 0
                ).getTime();
                const beginPrevious = new Date(
                  previousEpisode?.beginTime || 0
                ).getTime();
                if (beginPrevious < beginCurrent) {
                  const index = prevData.indexOf(previousEpisode);
                  prevData[index] = currentEpisode;
                }
                return prevData;
              }
            }
            return [...prevData, currentEpisode];
          }, []);

        let episodesString = TranslationManager.get('MISC.EPISODES');
        if (episodes.length === 1)
          episodesString = episodesString.substring(
            0,
            episodesString.length - 1
          );

        const rail = {
          section: {
            title: `${TranslationManager.get('MISC.EVENTS.SEASON')} ${
              item?.season || ''
            } | ${episodes.length} ${episodesString}`,
            presentationType: RailDisplayMode.PHOTO,
            name: item?._id,
          },
          shows: {
            data: episodes,
            totalEpisodes: episodes?.length ? item?.totalEpisode : undefined,
          },
        };
        return new Rail(rail as IRailData);
      }, []);

      rails = rails.filter((item) => {
        return item.data.length;
      });
      resolve(rails);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}
